import { lazy, Suspense } from 'react'
import { Outlet, RouteObject } from 'react-router'
import { SuspenseLoading } from '@/common/components/SuspenseLoading.tsx'
import { OnboardingRecordDetailsProvider } from '@/pages/onboarding/onboarding-details/useOnboardingRecordDetails.ts'
import { DocumentStorageConfigProvider } from '@/pages/employee-data/hooks/useDocumentStorageConfig.tsx'

const OnboardingListPage = lazy(() => import('@/pages/onboarding/onboarding-list/onboarding-list-page.tsx'))
const OnboardingDetailsPage = lazy(() => import('@/pages/onboarding/onboarding-details/onboarding-details-page.tsx'))


export const onboardingRoutes: RouteObject = {
  path: 'onboarding',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <Suspense fallback={<SuspenseLoading />}><OnboardingListPage /></Suspense>,
    },
    {
      path: ':onboardingRecordId',
      element: <Suspense fallback={<SuspenseLoading />}>
        <DocumentStorageConfigProvider documentBucket="onboarding">
          <OnboardingRecordDetailsProvider>
            <OnboardingDetailsPage />
          </OnboardingRecordDetailsProvider>
        </DocumentStorageConfigProvider>
      </Suspense>,
    },
  ],
}
